import type { ContactPoint } from '@medplum/fhirtypes'

export const CONTACT_METHOD_SYSTEMS = [
  'phone',
  'email',
  'fax',
  'sms',
] as const satisfies readonly ContactPoint['system'][]

export type ContactMethodSystem = (typeof CONTACT_METHOD_SYSTEMS)[number]

interface ContactInfoResource {
  telecom?: ContactPoint[]
}

function isContactMethod(point: ContactPoint): boolean {
  return CONTACT_METHOD_SYSTEMS.includes(point.system as ContactMethodSystem)
}

export function getContactMethods(
  resource: ContactInfoResource
): ContactPoint[] {
  return (resource.telecom ?? []).filter(isContactMethod)
}

export function setContactMethods(
  resource: ContactInfoResource,
  methods: ContactPoint[]
): void {
  const hidden = (resource.telecom ?? []).filter(
    (point) => !isContactMethod(point)
  )
  const telecom = [...methods, ...hidden]
  // Empty FHIR arrays fail validation; clear the field instead.
  resource.telecom = telecom.length > 0 ? telecom : undefined
}
